// extracted by mini-css-extract-plugin
export default {"container":"eK+UG","header":"uowIH","breadcrumbs":"_0IFf4"};